import React from 'react';
import { Clock, Package, Truck, CheckCircle, AlertCircle } from 'lucide-react';
import { Badge } from '../ui/badge';

const CONFIG = {
  pending: { color: 'bg-yellow-500', icon: Clock },
  processing: { color: 'bg-blue-500', icon: Package },
  shipped: { color: 'bg-purple-500', icon: Truck },
  delivered: { color: 'bg-green-500', icon: CheckCircle },
  cancelled: { color: 'bg-red-500', icon: AlertCircle },
};

export const OrderStatusBadge = ({ status }) => {
  const c = CONFIG[status] || CONFIG.pending;
  const Icon = c.icon;
  return (
    <Badge className={`${c.color} text-white flex items-center gap-1`}>
      <Icon className="w-3 h-3" />
      {status}
    </Badge>
  );
};
